module.exports = __webpack_public_path__ + "img/excavator-dark-grey.b93c4ab7.svg";